<template>
    <div class="modal fade" id="dialogModal" tabindex="-1" aria-labelledby="dialogModalLabel" aria-hidden="false" ref="openDialogBtnRef">
    <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
        <div class="modal-header">
            <h1 class="modal-title fs-6" id="dialogModalLabel">{{ modalSetting.modalNm }}</h1>
        </div>
        <div class="modal-body">
            <div class="table-responsive">
                <ElTextarea v-if="modalSetting.type !='alert'" v-model="modalSetting.msg"  :rows="10" maxlength="100" :label="'사유'"/>
                <ElTextarea v-else v-model="modalSetting.msg"  rows="10" :disabled="true" :label="'사유'"/>
            </div>
        </div>
        <div class="modal-footer display">
            <Message severity="error" v-if="dialogValue.isText">값을 입력해주세요.</Message>
            <ElButton v-if="modalSetting.type === 'confirm'" type="modelFooterConfirm"  @buttonClick="confirm()">확인</ElButton>
            <ElButton v-if="modalSetting.type === 'alert'" type="modelFooterConfirm"  @buttonClick="closeModal()">닫기</ElButton>
        </div>
        </div>
    </div>
    </div>

</template>
   
<script setup>
import {ref,onMounted, reactive,defineEmits, readonly} from 'vue'
import Message from 'primevue/message';
import common from '@/js/common';


let dialog
const openDialogBtnRef = ref()
// Promise 객체를 핸들링하기 위한 ref
const resolvePromise = ref(null);

const modalSetting = ref({
    type : '',
    modalNm : '',
    msg : ''
})

const dialogValue = reactive({
    isText : false,
    inText : ''
})


const emit = defineEmits(['updateValue','updateIndex']);

onMounted(()=>{
    dialog = new bootstrap.Modal(openDialogBtnRef.value,{
        backdrop: 'static',
        keyboard: false
    });
})

//dialog open
function openDialog(type,msg,titleMsg){
    switch(type) {
        case 'view':
            modalSetting.value.type = 'alert'
            modalSetting.value.modalNm = titleMsg
            modalSetting.value.msg = msg
            break;
        case 'confirm':
            modalSetting.value.type = 'confirm'
            modalSetting.value.modalNm = 'Confirm'
            modalSetting.value.msg = msg
            break;
        case  'text':
            modalSetting.value.type = 'confirm'
            modalSetting.value.modalNm = titleMsg
            modalSetting.value.msg = msg
            break;
        default:
            modalSetting.value.type = 'dialog'
            modalSetting.value.modalNm = 'Dialog'
            modalSetting.value.msg = ''
            break;
    }
    dialog.show();
    // const {Promise,reject,resolve} = Promise.with
    return new Promise((resolve) => {
        resolvePromise.value = resolve;
    });
}

//모달창 닫기버튼 클릭
const cancel = ()=>{
    dialog.hide()
    emit('updateValue', dialogValue.inText);
    resolvePromise.value(false);
}

const checkvalue = () =>{
    console.log('common.isEmpty(modalSetting.value.msg)',common.isEmpty(modalSetting.value.msg))
   return common.isEmpty(modalSetting.value.msg)
}

//모달창 확인버튼 클릭
const confirm = () => {
    
    if(!checkvalue()){
        emit('updateValue', modalSetting.value.msg);
        dialog.hide()
        resolvePromise.value(true);
    }else{
        dialogValue.isText = true
        setTimeout(() => {
            dialogValue.isText = false
        }, 2000);
    }
   
}

const closeModal = () =>{
    dialog.hide()
    resolvePromise.value(true);
}


defineExpose({
    openDialog
})


</script>

<style>
.display {
    display: flex;
    align-items: center; /* 수직 정렬 */
    width: 100%; /* 부모 요소의 전체 너비 사용 */
}

.display > Message {
    flex-grow: 1; /* 남은 공간을 차지하여 왼쪽 끝으로 정렬 */
}

.display > ElButton {
    margin-left: auto; /* 오른쪽 끝으로 이동 */
}


</style>
   